export default __webpack_public_path__ + "static/media/awardedBg.3aa41052.png";